export default __webpack_public_path__ + "static/media/hero-progress.b4afcff2.svg";